import { connect } from 'react-redux';
import { goToResultPage } from '../BreadcrumbsActions';
import { breadcrumbById } from '../BreadcrumbsSelectors';
import Breadcrumb from './Breadcrumb';

function mapStateToProps(state, ownProps) {
  return {
    breadcrumb: breadcrumbById(state, ownProps),
  };
}

const mapDispatchToProps = {
  goToResultPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb);
